import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { EditNutritionPlanPage } from 'pages/edit-nutrition-plan/edit-nutrition-plan';

@NgModule({
    declarations: [EditNutritionPlanPage],
    imports: [PagesModule, ComponentsModule],
    exports: [EditNutritionPlanPage]
})
export class EditNutritionPlanPageModule { }
